import { Injectable } from "@angular/core";
import { ChatbotResource } from "core/stages-client";
import MessageFeedback = stages.chatbot.MessageFeedback;

@Injectable({
	providedIn: "root",
})
export class FeedbackService {
	constructor(private readonly chatbotResource: ChatbotResource) {}

	async submitFeedback(userFeedback: MessageFeedback): Promise<void | null> {
		return this.chatbotResource.saveMessageFeedback(userFeedback);
	}
}
